import React from 'react';

import OpenTokenSimulator from '../components/ItemPage';

const OpenTokenSimulatorContainer = () => {
  return <OpenTokenSimulator />;
};

export default OpenTokenSimulatorContainer;
